import type { TestableComponent } from '@mweb/types';
import { type TabsTriggerProps } from '@radix-ui/react-tabs';
import type { ReactElement } from 'react';
import UtilityStrokeCheckFilledMediumIcon from '@mweb/zappos-ui/Icons/UtilityStrokeCheckFilledMediumIcon';
import UtilityStrokeMinusCircleMediumIcon from '@mweb/zappos-ui/Icons/UtilityStrokeMinusCircleMediumIcon';

import { TabsTrigger } from 'components/productdetail/ReviewSummarization/Tabs';
import useMartyContext from 'hooks/useMartyContext';
import type { ReviewSummarizationResponseAspects, ReviewSummarizationResponseSentiment } from 'types/reviewSummarization';

export interface TabsHeaderProps extends Omit<TabsTriggerProps, 'value'>, Pick<ReviewSummarizationResponseAspects, 'sentiment'>, TestableComponent {
  children: string;
  handleOpenTab: (tab: string) => void;
}

const SentimentIconMap: Record<ReviewSummarizationResponseSentiment, ReactElement | undefined> = {
  Positive: <UtilityStrokeCheckFilledMediumIcon size={24} className="stroke-reversed text-success-inline" />,
  Negative: <UtilityStrokeMinusCircleMediumIcon size={24} className="fill-alert-inline stroke-2 text-reversed" />,
  Mixed: undefined
};

export const TabsHeader = (props: TabsHeaderProps) => {
  const { testId, sentiment, children, handleOpenTab } = props;
  const { testId: getTestId } = useMartyContext();

  return (
    <TabsTrigger value={children} data-test-id={getTestId(testId)} onClick={() => handleOpenTab(children)}>
      {SentimentIconMap[sentiment]}
      {children}
    </TabsTrigger>
  );
};
